<match-details
  *ngIf="matchId"
  [isVacancy]="true"
  [matchId]="matchId" 
  (onClose)="matchId = null">
</match-details>

<div class="vacancy-connenct-popup-bg" *ngIf="showVacancyList" (click)="toggleList()" @opacityInOut></div>
<div class="vacancy-connenct-popup" *ngIf="showVacancyList" @scaleInOut>
  <div class="vacancy-connenct-popup__header">
    <h2>Connect talent with vacancy</h2>
    <i class="app-ico-mask app-ico-mask__x" (click)="toggleList()"></i>
  </div>
  <div class="vacancy-connenct-popup__top-shadow"></div>
  <div class="vacancy-connenct-popup__main is-scroll">
    <div class="a-section vacancy-connenct-popup__item"
      *ngFor="let item of vacancyMatchList; let i = index;">
      <input
        id="radio-{{ i }}"
        [value]="item.id" 
        (change)="onChange($event)"
        [checked]="item.id === selectedId" 
        name="radio" 
        type="radio">
      <label for="radio-{{ i }}" class="radio-label">
        <div>
          <div class="vacancy-connenct-popup__item__name">
            {{ item.jobName ? item.jobName : item.jobPosition }}
          </div>
          <div class="vacancy-connenct-popup__item__date">
            <i class="app-ico-mask app-ico-mask__calendar"></i>
            Published {{ item.publishedAt | date: 'dd.MM.YY' }}
          </div>
        </div>
        <round-progress 
          [small]="true" 
          [score]="item.matchScore"
          (click)="selectMatch(item.matchId) ">
        </round-progress>
      </label>
    </div>
  </div>
  <div class="vacancy-connenct-popup__btns">
    <div class="vacancy-connenct-popup__bottom-shadow"></div>
    <div class="is-btn is-btn__outfill" (click)="toggleList()">Cancel</div>
    <div class="is-btn" [class.is-disabled]="!selectedId" (click)="connectToVacancy()">Connect</div>
  </div>
</div>

<div class="vacancy-connenct a-section" *ngIf="vacancyMatchList && vacancyMatchList.length">
  <div class="vacancy-connenct__title">
    You have several positions for this talent
  </div>
  <div>
    Connect one of the positions that best suits communication with this talent
  </div>
  <div class="vacancy-connenct__btns">
    <div class="is-btn" (click)="toggleList()">Connect</div>
  </div>
  <div class="is-separator"></div>
  <div>
    Create new position and see how this talent match for your company
  </div>
  <div class="vacancy-connenct__btns">
    <div class="is-btn is-btn__outfill" (click)="createVacancy()">Create position</div>
  </div>
</div>

<div class="vacancy-connenct a-section" *ngIf="!vacancyMatchList || (vacancyMatchList && !vacancyMatchList.length)">
  <div class="vacancy-connenct__title">
    You have no open positions for this talent
  </div>
  <div>
    Create a position now and see how this talent match for your company
  </div>
  <div class="vacancy-connenct__btns">
    <div class="is-btn" (click)="createVacancy()">Create position</div>
  </div>
</div>